<template>
  <form name="contract" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class="row mt-3">
      <div class="col-md-7">
        <div class="form-group">
          <label for="customerId"
            >Cliente <span v-if="!bonus.id" class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <SelectCustomers
              ref="customerId"
              :selected="bonus.customerId"
              :first="'Selecione um cliente'"
              @change="bonus.customerId = $event"
              :disabled="!!bonus.id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="productId"></label>
          <div class="clear-link">
            <a href="javascript:;" id="m_login_forget_password" @click="clearBonus()" class="m-link"
              >Limpar Formulário</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3">
        <div class="form-group">
          <label for="date">Tipo de bônus<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeBonus"
                  id="typeBonusSaldo"
                  value="1"
                  v-model="bonus.bonusType"
                  :checked="true"
                />
                Saldo
              </label>
            </div>
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeBonus"
                  id="typeBonusUnico"
                  value="2"
                  v-model="bonus.bonusType"
                />
                Único
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <label for="date">Aplicar de<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="bonus.startDate"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="date">Aplicar até</label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="bonus.endDate"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <label for="productId">Produto <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectProducts
                id="productId"
                ref="productId"
                :first="'Selecione um produto'"
                :selected="bonus.productId"
                @change="updateProductIdValue($event)"
                v-model="bonus.productId"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="productId">Motivo <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectBonusReasons
                id="reasonId"
                ref="reasonId"
                :first="'Selecione um motivo'"
                :selected="bonus.reasonId"
                @change="updateReasonIdValue($event)"
                v-model="bonus.reasonId"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <label for="justification">Justificativa</label>
        <div class="input-group">
          <input
            id="note"
            type="text"
            class="form-control"
            placeholder=""
            v-model="data.justification"
          />
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div v-for="service in bonus.services" :key="service.id" class="row mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <label for="productId">Serviço <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectProductServices
                id="serviceId"
                ref="serviceId"
                :first="'Selecione um serviço'"
                :selected="service.serviceId"
                :productId="bonus.productId"
                @change="service.serviceId = $event"
                :servicesSelected="bonus.services"
                :getCountable="1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="productId">Quantidade <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <input
                type="number"
                step="1"
                min="0"
                max="999999999"
                class="form-control"
                v-model="service.amount"
                placeholder="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-sm btn-metal m-btn" @click="bonus.services.push({})">
        <i class="fas fa-plus-circle"></i> Adicionar valor
      </button>
    </div>
    <hr class="row mt-5 mb-3" />

    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!this.bonus.customerId"
            >O campo <strong>Cliente</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="isEmpty(this.bonus.productId)"
            >O campo <strong>Produto</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="isEmpty(this.bonus.reasonId)"
            >O campo <strong>Motivo</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="isEmpty(this.bonus.startDate) && bonus.bonusType == 1"
            >O campo <strong>Aplicar de</strong> é obrigatório para o bônus tipo Saldo *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="isEmpty(this.bonus.startDate) && bonus.bonusType == 2"
            >O campo <strong>Aplicar de</strong> é obrigatório para o bônus tipo Único *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customerId.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!this.bonus.services[0].amount || !this.bonus.services[0].serviceId"
            >O campo <strong>Serviço e Quantidade bônus</strong> são obrigatórios *</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectProducts from '@/components/forms/SelectProducts';
import SelectProductServices from '@/components/forms/SelectProductServices';
import SelectBonusReasons from '@/components/forms/SelectBonusReasons';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';

import { baseApiUrl } from '@/global';
import axios from 'axios';
import snakecaseKeys from 'snakecase-keys';
import SelectCustomers from '../forms/SelectCustomers';

const getEmptyBonus = ({
  customerId = null,
  bonusType = '1',
  startDate = null,
  endDate = null,
  productId = null,
  reasonId = null,
  services = [{ serviceId: null, amount: 0 }],
}) => ({
  customerId,
  bonusType,
  startDate,
  endDate,
  productId,
  reasonId,
  services,
});

export default {
  mixins: [returnMessageFormMixin],
  name: 'CreateBonusForm',
  components: {
    SelectCustomers,
    SelectProducts,
    SelectBonusReasons,
    VueMonthlyPicker,
    SelectProductServices,
  },
  data() {
    return {
      justification: null,
      bonus: getEmptyBonus({}),
      reasons: [],
      items: [],
      monthsLabels: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      this.bonus.startDate = `${moment(this.bonus.startDate).format('YYYY-MM')}-01`;
      if (this.bonus.endDate) {
        this.bonus.endDate = `${moment(this.bonus.endDate).format('YYYY-MM')}-01`;
      }

      this.bonus.justification = this.data.justification;

      const url = `${baseApiUrl}/v1/customer/bonus/create`;
      axios
        .post(url, snakecaseKeys(this.bonus))
        .then((res) => {
          this.logMessageForm(res);
          this.bonus = getEmptyBonus({});
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    updateProductIdValue(productId) {
      this.bonus.productId = productId;
    },
    updateReasonIdValue(reasonId) {
      this.bonus.reasonId = reasonId;
    },
    callData() {
      this.getCustomersWithDiscounts();
    },
    clearBonus() {
      this.bonus = getEmptyBonus({});
      this.bonus.customerId = 0;
    },
    isEmpty(value) {
      if (value === '' || value == null || value == 0) {
        return true;
      }
      return false;
    },
  },
  computed: {
    formIsValid() {
      if (
        this.bonus.customerId &&
        !this.isEmpty(this.bonus.productId) &&
        !this.isEmpty(this.bonus.reasonId) &&
        !this.isEmpty(this.bonus.bonusType) &&
        ((this.bonus.startDate && this.bonus.bonusType == 1) ||
          (this.bonus.startDate && this.bonus.bonusType == 2)) &&
        this.bonus.services[0].amount &&
        this.bonus.services[0].serviceId
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    this.data = {
      customerId: 0,
      productId: 0,
      startDate: '',
      endDate: '',
    };
  },
};
</script>

<style scoped>
.clear-link {
  margin-top: 18px;
}
.btn-collapse {
  border-color: transparent;
  margin-top: 5px;
}
.radio {
  margin: auto;
}
</style>
